module.exports = __webpack_public_path__ + "praise.17a6c605.png";